import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
// import ApplicantDashboard from "./components/applicantDashboard/ApplicantDashboard";
// import OfficeDashboard from "./components/officeDashboard/OfficeDashboard";
// import Header from './home/components/layout/Header';
// import Footer from './home/components/layout/Footer';
// import Home from './home/components/home/Home';
// import Login from './home/components/auth/Login';
// import OfficeLogin from './home/components/auth/OfficeLogin';
// import Registration from './home/components/Registration';
// import ForgotPassword from './home/components/auth/ForgotPassword';
 import PasswordAdmin from './PasswordAdmin';

import OfficeDashboard from './pages/OfficeDashboardPage';
import ApplicantDashboard from './pages/ApplicantDashboardPage';
import Registration from './components/LandingPage/Registration';
import Login from './components/LandingPage/ApplicantLogin';
import OfficeLogin from './components/LandingPage/OfficeLogin';
import Footer from './components/LandingPage/Footer';
import Header from './components/LandingPage/Header';
import LandingPage from './pages/LandingPage';
import './App.css';
import { initAnimations } from './services/animation';
import SApp from './special/App.js';

const AppContent = () => {
  const location = useLocation();
  const [showLogin, setShowLogin] = useState(false);
  const [showOfficeLogin, setShowOfficeLogin] = useState(false);
  const [showRegistration, setShowRegistration] = useState(false);
  const [showForgotPassword, setForgotPassword] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [showFooter, setShowFooter] = useState(true);

  useEffect(() => {
    // Hide header and footer if path is /ApplicantDashboard or /OfficeDashboard
    const hideHeaderFooter = location.pathname === "/ApplicantDashboard" || location.pathname === "/OfficeDashboard" || location.pathname === "/PartPlanForm" || location.pathname === "/ZoneForm" || location.pathname === "/PartPlanForm/" || location.pathname === "/ZoneForm/" || location.pathname === "/admin/" || location.pathname === "/PartPlanFormPayment/" || location.pathname === "/PartPlanDashboard/" || location.pathname === "/ZoneFormPayment/" || location.pathname === "/ZoneDashboard/" || location.pathname === "/PartPlanDashboard" || location.pathname === "/ZoneDashboard" || location.pathname === "/head" || location.pathname === "/Amravati" || location.pathname === "/Chhatrapati_Sambhaji_Nagar" || location.pathname === "/Kokan" || location.pathname === "/Nagpur"|| location.pathname === "/Nashik" || location.pathname === "/Pune" || location.pathname === "/s";
 
    setShowHeader(!hideHeaderFooter);
    setShowFooter(!hideHeaderFooter);
  }, [location]);

  useEffect(() => {
    // Initialize scroll animations
    const cleanup = initAnimations();
    return typeof cleanup === "function" ? cleanup : undefined;
  }, []);

  const handleLoginClick = () => {
    setShowLogin(true);
    setShowRegistration(false);
    setForgotPassword(false);
  };


  const handleForgotPasswordClick = () => {
    setShowLogin(false);
    setShowRegistration(false);
    setForgotPassword(true);
  };

  const handleCloseForgotPasswordClick = () => setForgotPassword(false);

  const handleCloseLogin = () => setShowLogin(false);
  const handleRegisterClick = () => {
    setShowRegistration(true);
    setShowLogin(false);
    setForgotPassword(false);
  };

  const handleCloseRegistration = () => setShowRegistration(false);

  const handleOfficeLoginOpen = () => setShowOfficeLogin(true);
  const handleOfficeLoginclose = () => setShowOfficeLogin(false);

  return (
    <div className="app">

      {showHeader && <Header onLoginClick={handleLoginClick} onOfficeClick={handleOfficeLoginOpen} />}

      <main className="main-content">
        <Routes>
          <Route path="/" element={<LandingPage onLoginClick={handleLoginClick} onRegisterClick={handleRegisterClick} />} />
         <Route path="/ApplicantDashboard" element={<ApplicantDashboard />} />
          <Route path="/OfficeDashboard" element={<OfficeDashboard />} />
           <Route path="/admin" element={<PasswordAdmin />} />

           <Route path="/s" element={<SApp />} />
          {/* <Route path="/ApplicantDashboard" element={<ApplicantDashboard />} />
          <Route path="/OfficeDashboard" element={<OfficeDashboard />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/admin" element={<PasswordAdmin />} />  */}

        </Routes>
      </main>

      {showFooter && <Footer />}
      {showLogin && (
        <div className="modal-overlay visible">
          <div className="modal-content">
            <Login onClose={handleCloseLogin} onSwitchToRegister={handleRegisterClick} handleForgotPasswordClick={handleForgotPasswordClick} />
          </div>
        </div>
      )}
      {showOfficeLogin && (
        <div className="modal-overlay visible">
          <div className="modal-content">
            <OfficeLogin onClose={handleOfficeLoginclose} />
          </div>
        </div>
      )}
      {showRegistration && (
        <div className="modal-overlay visible">
          <div className="modal-content">
            <Registration onClose={handleCloseRegistration} onSwitchToLogin={handleLoginClick} />
          </div>
        </div>
      )}

      {/* {showForgotPassword && (
        <div className="modal-overlay visible">
          <div className="modal-content">
            <ForgotPassword onClose={handleCloseForgotPasswordClick} />
          </div>
        </div>
      )}  */}
      
    </div>
  );
};

const App = () => (
  <BrowserRouter basename="/client/build">
    <AppContent />
  </BrowserRouter>
);

export default App;
